import { render, staticRenderFns } from "./PolicySubItem.vue?vue&type=template&id=36c3f8e2&"
import script from "./PolicySubItem.vue?vue&type=script&lang=js&"
export * from "./PolicySubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports